"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drillActions = exports.drillSliceReducer = void 0;
// (C) 2021 GoodData Corporation
var toolkit_1 = require("@reduxjs/toolkit");
var drillReducers_1 = require("./drillReducers");
var drillState_1 = require("./drillState");
var drillSlice = toolkit_1.createSlice({
    name: "meta",
    initialState: drillState_1.drillInitialState,
    reducers: drillReducers_1.drillReducers,
});
exports.drillSliceReducer = drillSlice.reducer;
exports.drillActions = drillSlice.actions;
//# sourceMappingURL=index.js.map